module.exports = __webpack_public_path__ + "static/media/no_image.51bddc7b.png";